


































































import { Component, Vue } from "vue-property-decorator";
import { UserWalletDetailed, UserGoldDetailed } from "@/req/pay";
@Component({
  components: {}
})
export default class Home extends Vue {
  public activeTabs = 0; // 初始默认
  public dataValue = "";
  public tabs = [
    {
      name: "余额明细"
    },
    {
      name: "金币明细"
    }
  ];
  public active = "toDay";
  public versionList = [
    {
      id: 1,
      name: "直充游戏"
    },
    {
      id: 2,
      name: "余额充值到游戏"
    },
    {
      id: 3,
      name: "金币充值到游戏"
    }
  ];
  public cityList = [];
  public total = 10;
  public gainSum = "";
  public costSum = "";
  public columns = [
    {
      title: "开服时间",
      key: "pay_time",
      align: "center",
      width: 207,
      render: (h, params) => {
        return h(
          "span",
          {
            props: {}
          },
          this.$fn.toTimes(params.row.pay_time)
        );
      }
    },
    {
      title: "交易订单号",
      key: "pay_order",
      align: "center",
      width: 242
    },
    {
      title: "交易类型",
      key: "pay_way",
      slot: "way",
      align: "center",
      width: 179
    },
    {
      title: "收入",
      key: "pay_amount",
      align: "center",
      width: 139
    },
    {
      title: "支出",
      key: "consume",
      align: "center",
      width: 139
    },
    {
      title: "交易结果",
      slot: "follow",
      align: "center",
      width: 139
    }
  ];
  public data = [];
  public model1 = "";
  public sStime = "";
  public eEtime = "";
  public page = "";
  public versionid = "";

  public mounted() {
    this.getList();
  }
  public tabsSkip(index) {
    this.activeTabs = index;
    this.page = "";
    this.getList();
  }
  public async getList() {
    const obj = {
      token: this.$fn.cookies.getToken(),
      stime: this.sStime,
      etime: this.eEtime,
      page: this.page,
      type: this.versionid
    };
    let res;
    if (this.activeTabs == 0) {
      res = await UserWalletDetailed(obj);
    } else {
      res = await UserGoldDetailed(obj);
    }
    if (res.code == 200) {
      this.data = res.data.payData;
      this.gainSum = res.data.income;
      this.costSum = res.data.income;
    }
  }
  public changeDate(date) {
    this.sStime = date[0]; // this.$fn.dateToNum(date[0]);
    this.eEtime = date[1]; // this.$fn.dateToNum(date[1]);
    this.page = "";
    this.getList();
  }
  public changeType() {
    this.page = "";
    this.getList();
  }
  // 页面跳转
  public changepage(index) {
    this.page = index;
    this.getList();
  }
}
